import React, { useEffect, useState } from "react";
import { getAllWagons, getWagonByFilter } from "../Service/WagonService";
import { useToast } from "../Components/toast/ToastProvider";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import WagonFilter from "../Components/WagonFilter";
import { Button, Table } from "react-bootstrap";
import { formatDate } from "../config/function";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "react-feather";

const WagonReportPages = () => {
  const toast = useToast();
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    station: "",
  });
  const [filteredWagon, setFilteredWagon] = useState([]);
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchStationsFromWagon();
  }, []);

  const fetchStationsFromWagon = async () => {
    try {
      const res = await getAllWagons();

      const uniqueStations = [...new Set(res.data.map((w) => w.station))];

      const formatted = uniqueStations.map((s) => ({
        label: s,
      }));

      setStations(formatted);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFind = async () => {
    if (!filters.from_date && !filters.to_date && !filters.station) {
      toast("Please select at least one filter", "ERROR");
      return;
    }
    setLoading(true);
    try {
      const res = await getWagonByFilter(filters);
      setTimeout(() => {
        setFilteredWagon(res.data || []);
        setLoading(false);
      }, 1500);
    } catch (err) {
      toast(err.error || "Failed to filter trips", "ERROR");
    }
  };
  const handleReset = () => {
    setFilters({
      from_date: "",
      to_date: "",
      station: "",
    });
    setFilteredWagon([]);
  };

  const addPDFHeader = (doc, pageWidth) => {
    const logo = new Image();
    logo.src = "/img/asa_logo.png";

    const logoWidth = 18;
    const logoHeight = 18;
    const spacing = 5;

    const headerText = "ASA Transport";
    const subHeaderText = "Mannargudi";

    const headerWidth = doc.getTextWidth(headerText);
    const subHeaderWidth = doc.getTextWidth(subHeaderText);
    const totalWidth =
      logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
    const startX = (pageWidth - totalWidth) / 2;

    try {
      doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
    } catch (e) {
      console.warn("Logo load skipped (small size optimization)");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(headerText, startX + logoWidth + spacing, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subHeaderText, startX + logoWidth + spacing, 20);
  };

  const handleDownloadPDF = () => {
    if (filteredWagon.length === 0) {
      toast("No data to download", "ERROR");
      return;
    }

    const doc = new jsPDF({ orientation: "portrait", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    addPDFHeader(doc, pageWidth);

    autoTable(doc, {
      startY: 30,
      head: [["S.No", "Date", "Station", "Vehicle Count", "Advance"]],
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
      body: filteredWagon.map((wag, i) => [
        i + 1,
        formatDate(wag.date),
        wag.station,
        wag.vehicle_count,
        wag.advance?.toFixed(2),
      ]),
    });

    doc.save("wagon_report.pdf");
  };
  return (
    <div>
      <Main>
        <PageContainer>
          <CollapseCard title="Wagon Filter">
            <WagonFilter
              filters={filters}
              handleFilterChange={handleFilterChange}
              stations={stations}
              onFind={handleFind}
              onReset={handleReset}
              loading={loading}
            />
          </CollapseCard>
          <CollapseCard title="Wagon Details">
            <Table size="sm">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Station</th>
                  <th>Vehicle Count</th>
                  <th>Advance Amount</th>
                </tr>
              </thead>
              <tbody>
                {filteredWagon.length > 0 ? (
                  filteredWagon.map((wag, i) => {
                    return (
                      <tr key={wag.id}>
                        <td>{i + 1}</td>
                        <td>{formatDate(wag.date)}</td>
                        <td style={{ textTransform: "capitalize" }}>
                          {wag.station}
                        </td>
                        <td>{wag.vehicle_count}</td>
                        <td>{wag.advance.toFixed(2)}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No Wagon Data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CollapseCard>
          <div className="d-flex justify-content-end mb-2">
            <Button variant="success" onClick={handleDownloadPDF}>
              <Download /> Download PDF
            </Button>
          </div>
        </PageContainer>
      </Main>
    </div>
  );
};

export default WagonReportPages;
